import { useMediaQuery } from "./use-media-query";

/**
 * useReducedMotion — `true` when the user has opted out of animations.
 *
 * Component pattern: pair with the `motion` primitive's `transition` /
 * `animate` props, or simply skip non-essential motion when this returns
 * `true`. Note: `packages/ui/src/styles.css` already neutralises CSS
 * animations globally under `@media (prefers-reduced-motion: reduce)`, so
 * this hook is mostly for JS-driven motion (Framer Motion, requestAnimationFrame).
 */
export function useReducedMotion(): boolean {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
